import {GroupCriticalIllness} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/GroupCriticalIllness';
import {NewYorkCriticalIllness} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/NewYorkCriticalIllness';
import {OrdinaryCriticalIllness} from 'ApplicationEntry/models/ProductsRiders/CriticalIllness/OrdinaryCriticalIllness';

export type CriticalIllness = OrdinaryCriticalIllness | GroupCriticalIllness | NewYorkCriticalIllness;

type ExhaustiveCriticalIllnessOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryCriticalIllness) => TReturn;
  Group: (group: GroupCriticalIllness) => TReturn;
  NewYork: (newYork: NewYorkCriticalIllness) => TReturn;
};

type PartialCriticalIllnessOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryCriticalIllness) => TReturn;
  Group?: (group: GroupCriticalIllness) => TReturn;
  NewYork?: (newYork: NewYorkCriticalIllness) => TReturn;
  _: (app: CriticalIllness) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: CriticalIllnessByTypeOptions<TReturn>
): options is ExhaustiveCriticalIllnessOptionsByType<TReturn> =>
  !!options.Ordinary || (!!options.Group && !!options.NewYork);

type CriticalIllnessByTypeOptions<TReturn> =
  | PartialCriticalIllnessOptionsByType<TReturn>
  | ExhaustiveCriticalIllnessOptionsByType<TReturn>;

export const matchCriticalIllnessByType = <TReturn>(options: CriticalIllnessByTypeOptions<TReturn>) => (
  app: CriticalIllness
): TReturn => {
  switch (app.key) {
    case 'InvalidOrdCriticalIllness':
    case 'ValidOrdCriticalIllness':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupCriticalIllness':
    case 'ValidGroupCriticalIllness':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkCriticalIllness':
    case 'ValidNewYorkCriticalIllness':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidCriticalIllness = (criticalIllness: CriticalIllness) =>
  criticalIllness.key === 'ValidOrdCriticalIllness' ||
  criticalIllness.key === 'ValidGroupCriticalIllness' ||
  criticalIllness.key === 'ValidNewYorkCriticalIllness';
